import type { Distance, Rectangle } from "@pdfking/math"
import type { PlotShape } from "../plot/PlotShape"

export type Page = Readonly<
  {
    bleed?: Distance
    shapes: PlotShape[]
  } & Rectangle<Distance>
>
